module.exports = __webpack_public_path__ + "resource/img/admin.f76feaf5.svg";